/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';

/**
 * 
 * @export
 * @interface PaymentMethodDto
 */
export interface PaymentMethodDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    externalId: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodDto
     */
    created: Date;
}



/**
 * Check if a given object implements the PaymentMethodDto interface.
 */
export function instanceOfPaymentMethodDto(value: object): value is PaymentMethodDto {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function PaymentMethodDtoFromJSON(json: any): PaymentMethodDto {
    return PaymentMethodDtoFromJSONTyped(json, false);
}

export function PaymentMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'created': (new Date(json['created'])),
    };
}

export function PaymentMethodDtoToJSON(json: any): PaymentMethodDto {
    return PaymentMethodDtoToJSONTyped(json, false);
}

export function PaymentMethodDtoToJSONTyped(value?: PaymentMethodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'created': value['created'].toISOString(),
    };
}

